var render = function render(){var _vm=this,_c=_vm._self._c;return _c('playlist-page',{ref:"playlistPage",attrs:{"highlight-id":_vm.$route.params.trackId,"type":"album","id":_vm.id,"playlist":_vm.playlist}})
}
var staticRenderFns = []

export { render, staticRenderFns }